import { render } from "./ElementUpdateForm.vue?vue&type=template&id=52b54358&scoped=true"
import script from "./ElementUpdateForm.vue?vue&type=script&lang=js"
export * from "./ElementUpdateForm.vue?vue&type=script&lang=js"

import "./ElementUpdateForm.vue?vue&type=style&index=0&id=52b54358&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b54358"]])

export default __exports__